<template>
    <document-head title="Home"/>

    <app-layout>
        <div class="mt-8 flex flex-row justify-between">
            <h1 class="text-3xl font-semibold text-gray-900">Newest Levels</h1>
            <div>
                <Link class="mr-2 py-2 px-4 rounded text-white" style="background: #06F195;" :href="route('snail::levels.create')">
                    Upload Level
                </Link>
                <Link class="py-2 px-4 rounded text-white bg-gray-800" :href="route('snail::users.index')">
                    User List
                </Link>
            </div>
        </div>
        <div v-for="level in levels" class="mt-4 bg-white dark:bg-gray-800 overflow-hidden shadow sm:rounded-lg">
            <div class="p-6">
                <div class="flex items-center">
                    <div class="ml-4 leading-7">
                        <Link :href="route('snail::levels.show', level.id)"
                              class="text-lg font-semibold underline text-gray-900 dark:text-white">
                            {{ level.title }}
                        </Link>
                        <span class="text-gray-400 text-sm">&nbsp;By
                            <Link :href="route('snail::users.show', level.creator.id)" class="underline dark:text-white">
                                {{ level.creator.name }}
                            </Link>
                        </span>
                    </div>
                </div>
                <div class="ml-4">
                    <div class="mt-2 text-gray-600 dark:text-gray-400 text-sm">
                        {{ level.description }}
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>
<script>
import {Head as DocumentHead, Link} from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/Snail'
import BreezeDropdown from "@/Components/Dropdown";
import BreezeDropdownLink from "@/Components/DropdownLink";

export default {
    components: {
        AppLayout,
        DocumentHead,
        Link,
        BreezeDropdown,
        BreezeDropdownLink,
    },
    props: {
        auth: Object,
        levels: Array,
    },
}
</script>
